<template>
  <intersect @enter="animate = true">
    <div class="partnersContainer container" v-if="itemData">
      <div
        class="ttl fadeUp"
        v-if="_.get(itemData, 'conf.useHeader') == 1"
        :class="animate ? 'animate' : ''"
      >
        {{ _.get(itemData, "conf.header.title") }}
      </div>
      <div class="partnerSlOuter fadeUp" :class="animate ? 'animate' : ''">
        <swiper class="partnersSlider" :options="swiperPartnersOptions">
          <swiper-slide v-for="item in itemData.data" :key="item.id">
            <a
              :href="_.get(item, 'smartbuttons.0.url')"
              class="partnerItem"
              target="_blank"
            >
              <img
                :src="
                  _.get(item, ['images', Object.keys(item.images)[0], 'url'])
                "
                alt=""
                v-if="_.get(item, 'images')"
              />
            </a>
          </swiper-slide>
        </swiper>
        <div class="partnerPrev">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.013"
            height="21.906"
            viewBox="0 0 12.013 21.906"
          >
            <g
              id="Group_70"
              data-name="Group 70"
              transform="translate(42.561 -19626.655) rotate(-90)"
            >
              <path
                id="Path_61"
                data-name="Path 61"
                d="M0,9.892,9.892,0"
                transform="translate(-19637.607 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              ></path>
              <path
                id="Path_60"
                data-name="Path 60"
                d="M9.892,9.892,0,0"
                transform="translate(-19647.5 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              ></path>
            </g>
          </svg>
        </div>
        <div class="partnerNext">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.013"
            height="21.906"
            viewBox="0 0 12.013 21.906"
          >
            <g
              id="Group_70"
              data-name="Group 70"
              transform="translate(42.561 -19626.655) rotate(-90)"
            >
              <path
                id="Path_61"
                data-name="Path 61"
                d="M0,9.892,9.892,0"
                transform="translate(-19637.607 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              ></path>
              <path
                id="Path_60"
                data-name="Path 60"
                d="M9.892,9.892,0,0"
                transform="translate(-19647.5 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";
export default {
  props: {
    itemData: {
      type: Object,
      require: true
    }
  },
  components: {
    Intersect
  },
  data() {
    return {
      animate: false,
      swiperPartnersOptions: {
        speed: 800,
        spaceBetween: 0,
        watchOverflow: true,
        navigation: {
          nextEl: ".partnerNext",
          prevEl: ".partnerPrev"
        },
        breakpoints: {
          320: {
            slidesPerView: 1.3
          },
          768: {
            slidesPerView: 3
          },
          1366: {
            slidesPerView: 4
          },
          1440: {
            slidesPerView: 5
          },
          1680: {
            slidesPerView: 6
          }
        }
      }
    };
  },
  computed: {
    getPartners() {
      return this.$store.getters.getPartners;
    }
  }
};
</script>

<style>
@media (max-width: 767px) {
  .partnerSlOuter .swiper-container {
    overflow: visible;
  }
}
</style>